import { useQuery } from "react-query";
import { getAppointedBy } from "../../../../actions/Utilities/AppointedBy";

export const useAppointedBy = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetAppointedBy",
    getAppointedBy,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
